import { render, staticRenderFns } from "./MlbPositionOpti.vue?vue&type=template&id=2e667cd6&scoped=true"
import script from "./MlbPositionOpti.vue?vue&type=script&lang=js"
export * from "./MlbPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./MlbPositionOpti.vue?vue&type=style&index=0&id=2e667cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e667cd6",
  null
  
)

export default component.exports